import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./pages/AppRoutes";

// Core styles
import "./scss/volt.scss";

// Vendor styles
import "react-datetime/css/react-datetime.css";

// Componente ScrollToTop corrigido
import ScrollToTop from "./components/ScrollToTop";

// Render principal
ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter>
            {/* ScrollToTop deve envolver o AppRoutes */}
            <ScrollToTop>
                <AppRoutes />
            </ScrollToTop>
        </BrowserRouter>
    </React.StrictMode>,
    document.getElementById("root")
);
